// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__21ydR","header":"PatientQuestionnaire_header__3-d-h","info":"PatientQuestionnaire_info__13zzY"};